export enum InvoiceType {
  Normal = 1,
  InvertedVat = 2,
  Rot = 3,
  Rut = 4,
  Green = 5,
}
